import { render, staticRenderFns } from "./myViewsixth.vue?vue&type=template&id=6f82caf8&scoped=true"
import script from "./myViewsixth.vue?vue&type=script&lang=js"
export * from "./myViewsixth.vue?vue&type=script&lang=js"
import style0 from "./myViewsixth.vue?vue&type=style&index=0&id=6f82caf8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f82caf8",
  null
  
)

export default component.exports